/** "eav" module DTO unique keys */
export enum EavDtoKeysEnum {
  /** EAV attribute response body */
  EAV_ATTRIBUTE_FIND_DTO = 'eav/eav-attribute-find.dto',
  /** EAV attribute create and update APIs request body */
  EAV_ATTRIBUTE_FORM_DTO = 'eav/eav-attribute-form.dto',
  /** EAV entity type list APIs base filters */
  EAV_ENTITY_TYPE_FILTERS_DTO = 'eav/eav-entity-type-filters.dto',
  /** EAV entity type find many API query parameters (settings and filters) */
  EAV_ENTITY_TYPE_FIND_MANY_QUERY_DTO = 'eav/eav-entity-type-find-many-query.dto',
  /** EAV entity type find one API query parameters (additional options) */
  EAV_ENTITY_TYPE_FIND_ONE_QUERY_DTO = 'eav/eav-entity-type-find-one-query.dto',
  /** EAV entity type response body */
  EAV_ENTITY_TYPE_FIND_DTO = 'eav/eav-entity-type-find.dto',
  /** EAV entity type create and update APIs request body */
  EAV_ENTITY_TYPE_FORM_DTO = 'eav/eav-entity-type-form.dto',
  /** EAV entity type find many API response body */
  EAV_ENTITY_TYPE_PAGE_DTO = 'eav/eav-entity-type-page.dto',
  /** EAV entity type registry items page (with columns) */
  EAV_ENTITY_TYPE_ITEMS_PAGE_DTO = 'eav/eav-entity-type-items-page.dto',
  /** EAV entity type registry query parameters */
  EAV_ENTITY_TYPE_REGISTRY_QUERY_DTO = 'eav/eav-entity-type-registry-query.dto',
  /** EAV entity type column selection */
  EAV_ENTITY_TYPE_SELECT_DTO = 'eav/eav-entity-type-select.dto',
  /** EAV entity type sorting settings */
  EAV_ENTITY_TYPE_SORT_DTO = 'eav/eav-entity-type-sort.dto',
  /** EAV entity response body */
  EAV_ENTITY_FIND_DTO = 'eav/eav-entity-find.dto',
  /** EAV entity create and update APIs request body */
  EAV_ENTITY_FORM_DTO = 'eav/eav-entity-form.dto',
  /** Description of the token for EAV computed attribute */
  EAV_COMPUTED_ATTRIBUTE_TOKEN_DTO = 'eav/eav-computed-attribute-token.dto',
  /** EAV entity type tokens compute request body */
  EAV_ENTITY_TYPE_TOKENS_BODY_DTO = 'eav/eav-entity-type-tokens-body.dto',
}
